import React, { Component, PropTypes, cloneElement } from 'react';
import { connect } from 'react-redux';
import LoadingOverlay from '../tc-ui/loading-overlay';
import { getProfile } from '../../stores/profile/company/profile-actions';
import { getUserLocationProfile } from '../../stores/profile/location/location-actions';
import { getUserProductProfile } from '../../stores/profile/product/product-actions';
import { getNonLoggedInUsersProfile } from '../../stores/company/company/company-actions';
import { getNonLoggedInUsersLocationProfile } from '../../stores/company/location/location-actions';
import { getNonLoggedInUsersProductProfile } from '../../stores/company/product/product-actions';
import { getBadges } from '../../stores/profile/memberships/actions';

import R, { path, equals, merge, either, isNil, isEmpty, not, contains } from 'ramda';

const checkIfActiveRoute = (routeToCheck, pathname) => {
  const splitPath = pathname.split('/').slice(1);
  if (routeToCheck === 'profile' && splitPath.length === 1 && splitPath[0] === 'profile') return true;
  if (routeToCheck === 'profile-location' && splitPath.length === 3 && splitPath[0] === 'profile' && splitPath[1] === 'locations') return true;
  if (routeToCheck === 'profile-product' && splitPath.length === 3 && splitPath[0] === 'profile' && splitPath[1] === 'product') return true;
  if (routeToCheck === 'company' && splitPath.length === 2 && splitPath[0] === 'company') return true;
  if (routeToCheck === 'location' && splitPath.length === 2 && splitPath[0] === 'locations') return true;
  if (routeToCheck === 'product' && splitPath.length === 2 && splitPath[0] === 'product') return true;
  return false;
};

const isNilOrEmpty = either(isNil, isEmpty);

class ProfileRouter extends Component {

  constructor(props) {
    super(props);
  }

  componentWillMount() {
    const { dispatch } = this.props;
    this.getActiveProfile(this.props);
    dispatch(getBadges());
  }
  componentWillReceiveProps(nextProps) {
    const { history, profile } = this.props;
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.getActiveProfile(nextProps);
    } else if (checkIfActiveRoute('profile', nextProps.location.pathname) && nextProps.profile.refresh) {
      this.getActiveProfile(nextProps);
    } else if (checkIfActiveRoute('profile-location', nextProps.location.pathname) && nextProps.profileLocation.refresh) {
      this.getActiveProfile(nextProps);
    } else if (!profile.isMarketingReady && nextProps.isMarketingReady) {
      return history.push('/profile-complete-splash');
    }
  }

  getActiveProfile = (props) => {
    const {
      dispatch,
      profile,
      user,
      profileLocation,
      profileProduct,
      companyProfile,
      companyLocation,
      companyProduct,
      params,
      location,
    } = props;

    if (checkIfActiveRoute('profile', location.pathname)) {
      if (equals(path(['user', 'type'], user), 'Contractor')) {
        dispatch(getProfile(user.user.userID));
      } else if (!Object.keys(profile).length || profile.refresh) {
        dispatch(getProfile(user.user.userID));
      }
      if (user.company.oneOrMultiProperties === 'one-prop') dispatch(getUserLocationProfile(user.company.singleLocId));
    } else if (checkIfActiveRoute('profile-location', location.pathname)) {
      if (!profileLocation[params.locationId] || profileLocation.refresh) dispatch(getUserLocationProfile(params.locationId));
    } else if (checkIfActiveRoute('profile-product', location.pathname)) {
      if (!profileProduct[params.productId]) dispatch(getUserProductProfile(params.productId));
    } else if (checkIfActiveRoute('company', location.pathname)) {
      if (!companyProfile[params.companyId]) dispatch(getNonLoggedInUsersProfile(params.companyId));
    } else if (checkIfActiveRoute('location', location.pathname)) {
      if (!companyLocation[params.locationId]) dispatch(getNonLoggedInUsersLocationProfile(params.locationId));
    } else if (checkIfActiveRoute('product', location.pathname)) {
      if (!companyProduct[params.productId]) dispatch(getNonLoggedInUsersProductProfile(params.productId));
    }
  };

  _getRouteName = () => {
    const { params, profile, profileLocation, profileProduct, companyProfile, companyLocation, companyProduct, user } = this.props;
    if (checkIfActiveRoute('profile', this.props.location.pathname)) {
      return { routeName: 'profile', isEditable: R.contains('write', R.propOr([], 'corporateAccess', user)), profileToShow: user.company.oneOrMultiProperties === 'one-prop' ? merge(profile, profileLocation[user.company.singleLocId]) : profile };
    }
    if (checkIfActiveRoute('profile-location', this.props.location.pathname)) {
      const locationAccess = R.pathOr([], [0, 'profile'], user.locAccess.filter(obj => obj.locId === params.locationId));
      return { routeName: 'location', isEditable: R.contains('write', locationAccess), profileToShow: profileLocation[params.locationId] };
    }
    if (checkIfActiveRoute('profile-product', this.props.location.pathname)) {
      const locationAccess = R.pathOr([], [0, 'profile'], user.locAccess.filter(obj => obj.locId === R.pathOr('', [params.productId, 'locationId'], profileProduct)));
      return { routeName: 'product', isEditable: R.contains('write', locationAccess), profileToShow: profileProduct[params.productId] };
    }
    if (checkIfActiveRoute('company', this.props.location.pathname)) {
      return { routeName: 'profile', isEditable: false, profileToShow: companyProfile[params.companyId] };
    }
    if (checkIfActiveRoute('location', this.props.location.pathname)) {
      return { routeName: 'location', isEditable: false, profileToShow: companyLocation[params.locationId] };
    }
    if (checkIfActiveRoute('product', this.props.location.pathname)) {
      return { routeName: 'product', isEditable: false, profileToShow: companyProduct[params.productId] };
    }
  };

  render() {
    const { routeName, isEditable, profileToShow } = this._getRouteName();
    if ((typeof profileToShow === 'object' && !Object.keys(profileToShow).length) || !profileToShow) return false;
    const { children, ...props } = this.props;
    // if (
    //   routeName === 'product'
    //   && profileToShow.locationId
    //   && !this.props.profileLocation[profileToShow.locationId]
    // ) {
    //   this.props.dispatch(getUserLocationProfile(profileToShow.locationId));
    // }
    const extraProps = {
      profileToShow: merge(profileToShow, { viewingAs: this.props.profile.viewingAs }),
      isEditable,
      routeName,
      children,
      ...props,
    };
    return (
      <div>
        {children ? cloneElement(children, extraProps) : undefined}
        <LoadingOverlay
          loading={profileToShow.loading}
        />
      </div>
    );
  }

}

function select(state) {
  return {
    companyProfile: state.companyProfile.toJS(),
    companyLocation: state.companyLocation.toJS(),
    companyProduct: state.companyProduct.toJS(),
    profile: state.profile.toJS(),
    profileLocation: state.profileLocation.toJS(),
    profileProduct: state.profileProduct.toJS(),
    user: state.user.toJS(),
    MMReducer: state.marketingMaterials.mainReducer.toJS(),
    MMPartnerReducer: state.marketingMaterials.partnerReducer.toJS(),
  };
}

ProfileRouter.propTypes = {
  dispatch: PropTypes.func,
  profile: PropTypes.object,
  user: PropTypes.object,
  profileLocation: PropTypes.object,
  profileProduct: PropTypes.object,
  companyProfile: PropTypes.object,
  companyLocation: PropTypes.object,
  companyProduct: PropTypes.object,
  history: PropTypes.object,
  params: PropTypes.object,
  location: PropTypes.object,
  children: PropTypes.any,
};

export default connect(select, { })(ProfileRouter);



// WEBPACK FOOTER //
// ./src/app/components/profile/profileContainer.jsx